var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-container" },
    [
      _c(
        "div",
        { staticClass: "admin-content-container" },
        [
          [
            _c("div", { staticClass: "bar-row" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: {
                        disabled:
                          (_vm.chooseable && !!_vm.multiChoose.mode) ||
                          !_vm.hasPermission("download"),
                        icon: "el-icon-download",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleMultiSelect("download")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "wl-search-bar" },
                [
                  _c("div", { staticClass: "mr-15 invoice-tip" }, [
                    _vm._v(_vm._s(_vm.$t("admin.invoiceTip1"))),
                    _c("br"),
                    _vm._v(_vm._s(_vm.$t("admin.invoiceTip2"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green svg-btn",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: {
                        click: function ($event) {
                          return _vm.exportList("invoice")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Export_invoice_Items")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  !_vm.isNOT_LLP
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          attrs: { disabled: !_vm.hasPermission("download") },
                          on: {
                            click: function ($event) {
                              return _vm.exportList("fapiao")
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-export.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("Export_fapiao_Items")) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                class: [
                  "table-container-wrapper",
                  _vm.chooseable ? "show-table-bottom-operate" : "",
                ],
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "exchangeTable",
                    staticClass: "wl-table",
                    attrs: {
                      height: "100%",
                      data: _vm.data,
                      border: "",
                      stripe: "",
                    },
                    on: {
                      "select-all": (e) =>
                        _vm.handleSelectAll(e, _vm.list.data),
                      select: _vm.handleSelect,
                    },
                  },
                  [
                    _vm.chooseable
                      ? _c("el-table-column", {
                          attrs: { type: "selection", width: "50" },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 1,
                      attrs: {
                        prop: "entityNameEn",
                        width: "200",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.entityNameEn"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityNameEn")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityNameEn,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityNameEn",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 2,
                      attrs: {
                        prop: "entityNameCn",
                        width: "200",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.entityNameCn"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.entityNameCn")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.entityNameCn,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "entityNameCn",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 3,
                      attrs: {
                        prop: "issuanceDate",
                        width: "130",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.issuanceDate"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.issuanceDate")) +
                                        "\n                              "
                                    ),
                                    _c("DatePickerPopover", {
                                      attrs: {
                                        value: _vm.searchForm.issuanceDateRange,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "issuanceDateRange",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(scope.row.issuanceDate)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 4,
                      attrs: {
                        prop: "feeAmount",
                        width: "120",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.feeAmount"),
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "table-header" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "header-with-popup header-with-mount",
                                    },
                                    [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(_vm.$t("admin.feeAmount")) +
                                          "\n                              "
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            trigger: "click",
                                          },
                                          on: { hide: _vm.hidePopperSearch },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "th-filter-down",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._t("icon", function () {
                                                return [
                                                  _c("i", {
                                                    class: [
                                                      "el-icon-arrow-down",
                                                      _vm.searchForm
                                                        .feeAmountRange &&
                                                      _vm.searchForm
                                                        .feeAmountRange.length >
                                                        0
                                                        ? "el-icon-arrow-down-active"
                                                        : "",
                                                    ],
                                                  }),
                                                ]
                                              }),
                                            ],
                                            2
                                          ),
                                          _c("input-number-range", {
                                            staticClass:
                                              "input-amount-container",
                                            attrs: { precision: 2 },
                                            model: {
                                              value:
                                                _vm.searchForm.feeAmountRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searchForm,
                                                  "feeAmountRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchForm.feeAmountRange",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(
                                      _vm._f("formatNumThousandths")(
                                        scope.row.feeAmount
                                      )
                                    ) +
                                    "\n                      "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      key: 5,
                      attrs: {
                        prop: "totalAmount",
                        width: "140",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.totalAmount"),
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "table-header" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "header-with-popup header-with-mount",
                                    },
                                    [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(_vm.$t("admin.totalAmount")) +
                                          "\n                              "
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            trigger: "click",
                                          },
                                          on: { hide: _vm.hidePopperSearch },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "th-filter-down",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._t("icon", function () {
                                                return [
                                                  _c("i", {
                                                    class: [
                                                      "el-icon-arrow-down",
                                                      _vm.searchForm
                                                        .totalAmountRange &&
                                                      _vm.searchForm
                                                        .totalAmountRange
                                                        .length > 0
                                                        ? "el-icon-arrow-down-active"
                                                        : "",
                                                    ],
                                                  }),
                                                ]
                                              }),
                                            ],
                                            2
                                          ),
                                          _c("input-number-range", {
                                            staticClass:
                                              "input-amount-container",
                                            attrs: { precision: 2 },
                                            model: {
                                              value:
                                                _vm.searchForm.totalAmountRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searchForm,
                                                  "totalAmountRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchForm.totalAmountRange",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(
                                      _vm._f("formatNumThousandths")(
                                        scope.row.totalAmount
                                      )
                                    ) +
                                    "\n                      "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      key: 6,
                      attrs: {
                        prop: "invoiceCurrency",
                        width: "130",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.invoiceCurrency"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$t("admin.invoiceCurrency")
                                        ) +
                                        "\n                              "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 7,
                      attrs: {
                        prop: "invoiceNumber",
                        width: "140",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.invoiceNumber"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.$t("admin.invoiceNumber")) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value: _vm.searchForm.invoiceNumber,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "invoiceNumber",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 8,
                      attrs: {
                        prop: "invoiceContactEmail",
                        width: "200",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("admin.invoiceContactEmail"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$t("admin.invoiceContactEmail")
                                        ) +
                                        "\n                              "
                                    ),
                                    _c("InputPopover", {
                                      attrs: {
                                        value:
                                          _vm.searchForm.invoiceContactEmail,
                                        hidePopperSearch: _vm.hidePopperSearch,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.searchForm,
                                            "invoiceContactEmail",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "el-table-column",
                      {
                        key: 11,
                        attrs: {
                          prop: "settlementDate",
                          width: "140",
                          "show-overflow-tooltip": "",
                          label: _vm.$t("admin.settlementDate"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        scope.row.settlementDate
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c(
                            "div",
                            { staticClass: "header-with-popup" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("admin.settlementDate")) +
                                  "\n                                "
                              ),
                              _c("DatePickerPopover", {
                                attrs: {
                                  value: _vm.searchForm.settlementDateRange,
                                  hidePopperSearch: _vm.hidePopperSearch,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.searchForm,
                                      "settlementDateRange",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      key: 12,
                      attrs: {
                        prop: "status",
                        width: "160",
                        label: _vm.$t("admin.status"),
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("admin.status")) +
                                      "\n                                "
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.searchForm.statusList,
                                      labelKey: "label",
                                      valueKey: "value",
                                      inputFilterKey: ["label", "value"],
                                      options: _vm.categoryOptions,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "statusList",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex item-center" },
                                [
                                  _c("svg-icon", {
                                    staticClass: "mr-10",
                                    attrs: {
                                      "icon-name": _vm.renderStatusIcon(
                                        scope.row.status
                                      ),
                                      "icon-color": _vm.renderStatusColor(
                                        scope.row.status
                                      ),
                                      size: 20,
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.renderStatusColor(
                                          scope.row.status
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(`admin.${scope.row.status}`)
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 13,
                      attrs: {
                        prop: "overdueDays",
                        width: "200",
                        label: _vm.$t("admin.overdueDays"),
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "header-with-popup" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("admin.overdueDays")) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom",
                                          trigger: "click",
                                        },
                                        on: { hide: _vm.filterOverdueDays },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "th-filter-down",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._t("icon", function () {
                                              return [
                                                _c("i", {
                                                  class: [
                                                    "el-icon-arrow-down",
                                                    _vm.searchForm
                                                      .startOverdueDays ||
                                                    _vm.searchForm
                                                      .endOverdueDays
                                                      ? "el-icon-arrow-down-active"
                                                      : "",
                                                  ],
                                                }),
                                              ]
                                            }),
                                          ],
                                          2
                                        ),
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder: _vm.$t("minimum"),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.searchForm.startOverdueDays,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchForm,
                                                "startOverdueDays",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchForm.startOverdueDays",
                                          },
                                        }),
                                        _c("span", [_vm._v("~")]),
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder: _vm.$t("maximum"),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.searchForm.endOverdueDays,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchForm,
                                                "endOverdueDays",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchForm.endOverdueDays",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "overdue-days",
                                    style: _vm.overdueDaysStyle(
                                      scope.row.status
                                    ),
                                  },
                                  [
                                    scope.row.overdueDays === "NA"
                                      ? _c("span", [
                                          _vm._v(_vm._s(_vm.$t("admin.NA"))),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.status ===
                                                  "FULLY PAID"
                                                  ? _vm.$t(
                                                      "admin.overdueDaysFullDes",
                                                      {
                                                        t: scope.row
                                                          .overdueDays,
                                                      }
                                                    )
                                                  : _vm.$t(
                                                      "admin.overdueDaysDes",
                                                      {
                                                        t: scope.row
                                                          .overdueDays,
                                                      }
                                                    )
                                              )
                                          ),
                                        ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      key: 9,
                      attrs: {
                        prop: "fileList",
                        width: "120",
                        label: _vm.$t("admin.feeNote"),
                        fixed: "right",
                        "class-name": "file-name-cell",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fileList &&
                              scope.row.fileList.length > 0
                                ? [
                                    _vm.calcDisableDownload(
                                      scope.row.fileList[0]
                                    )
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                scope.row.fileList[0].name,
                                              placement: "top-start",
                                            },
                                          },
                                          [_c("span", [_vm._v("Bill.pdf")])]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "file-name can-download",
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.$t("preview"),
                                                  placement: "top-start",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "icon-preview",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.previewPdf(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-view",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    scope.row.fileList[0].name,
                                                  placement: "top-start",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFeeNote(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-download",
                                                    }),
                                                    _vm._v(
                                                      "\n                                      Bill.pdf\n                                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    !_vm.isNOT_LLP
                      ? _c("el-table-column", {
                          key: 10,
                          attrs: {
                            prop: "fapiao",
                            width: "100",
                            label: _vm.$t("admin.fapiao"),
                            "show-overflow-tooltip": "",
                            fixed: "right",
                            "header-align": "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "fapiao-col" },
                                      [
                                        scope.row.fapiaoQuantity
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "fee-note",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleFaPiaoDetail(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.fapiaoQuantity
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        scope.row.invoiceFlag
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    _vm.$t("admin.fapiaoTips"),
                                                  placement: "top-start",
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  staticClass: "mr-10",
                                                  attrs: {
                                                    "icon-name": "information",
                                                    "icon-color": "#fd349c",
                                                    size: 20,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3164567473
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 14,
                      attrs: {
                        width: "100",
                        label: _vm.$t("TABLE_HEAD_COMMENTS"),
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-with-popup header-one-center",
                                },
                                [
                                  _vm._v(
                                    "\n                                  " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                                  "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.searchForm.commentDate,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "commentDate",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex item-center justify-center",
                                },
                                [
                                  _c("i", {
                                    class: [
                                      scope.row.todayCommentCount > 0
                                        ? "wl-icon-messageBoard"
                                        : "wl-icon-messageBoardNull",
                                      "el-icon-s-comment",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleMessageBoardVisible(
                                          scope.row
                                        )
                                      },
                                    },
                                  }),
                                  scope.row.todayCommentCount
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "message-today" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.todayCommentCount
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", [_vm._v("/")]),
                                      ])
                                    : _vm._e(),
                                  scope.row.messageNum > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " " + _vm._s(scope.row.messageNum)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.chooseable
              ? _c(
                  "div",
                  { staticClass: "footer-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        attrs: { disabled: !_vm.chooseable },
                        on: { click: _vm.cancelChoose },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("btn_cancel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm.chooseable && _vm.multiChoose.mode == "download"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: { click: _vm.downloadConfirm },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("COMMON_DOWNLOAD")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-pagination",
              {
                staticClass: "wl-pagination",
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-size": _vm.pagination.pageSize,
                  layout: "prev, pager, next, slot, total",
                  total: _vm.pagination.total,
                },
                on: {
                  "current-change": _vm.onCurrentPageChange,
                  "size-change": _vm.onSizeChange,
                },
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.onSizeChange },
                        model: {
                          value: _vm.pagination.pageSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "pageSize", $$v)
                          },
                          expression: "pagination.pageSize",
                        },
                      },
                      _vm._l(_vm.pageOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _vm.fileDetailVisbile
        ? _c("file-detail", {
            attrs: {
              id: _vm.rowData.id,
              tableData: _vm.rowData.fileList,
              curUserName: _vm.curUserName,
              activeTab: "invoices",
              downloadAble: _vm.downloadAble,
              onCancel: _vm.toogleFileDetailVisible,
            },
            on: { "on-file-download": _vm.downloadFileDetail },
          })
        : _vm._e(),
      _c("file-confirm-modal", {
        ref: "FileConfirmModal",
        attrs: {
          fileDownloading: _vm.fileDownloading,
          groupList: _vm.hasSelectedList,
          curUserName: _vm.curUserName,
          downloadAble: _vm.downloadAble,
          mode: _vm.downloadDialogMode,
          type: "adminInvoice",
        },
        on: {
          ok: _vm.downloadMultipleFiles,
          "on-file-download": _vm.downloadFileDetail,
          updateMultipleSelection: _vm.updateMultipleSelection,
        },
      }),
      _vm.fapiaoBatchVisible
        ? _c("file-confirm-fapiao-modal", {
            attrs: {
              groupList: _vm.hasSelectedList,
              type: _vm.fileSelectionType,
              curUserName: _vm.curUserName,
              downloadAble: _vm.downloadAble,
              mode: _vm.downloadDialogMode,
            },
            on: {
              ok: _vm.downloadMultipleFiles,
              close: () => (_vm.fapiaoBatchVisible = !_vm.fapiaoBatchVisible),
              "on-file-download": _vm.downloadFileDetail,
              updateMultipleSelection: _vm.updateMultipleSelection,
            },
          })
        : _vm._e(),
      _vm.fileSelectionVisible
        ? _c("file-export-selection", {
            attrs: {
              onCancel: _vm.cancelBatchExport,
              onConfirm: _vm.saveSelectionType,
            },
          })
        : _vm._e(),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.getTableList,
              messageType: "6",
            },
          })
        : _vm._e(),
      _vm.fapiaoDetailVisible
        ? _c("fapiao-detail", {
            attrs: {
              id: _vm.rowData.id,
              row: _vm.rowData,
              curUserName: _vm.curUserName,
              downloadAble: _vm.downloadAble,
              onCancel: () =>
                (this.fapiaoDetailVisible = !this.fapiaoDetailVisible),
            },
            on: { "on-file-download": _vm.downloadFileDetail },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }